<template>
    <ul class="base-expandable-list">
        <li
            v-for="(item, index) in items"
            v-show="index < maxItems || expanded"
            :key="index"
            class="base-expandable-list__item"
        >
            <slot
                name="default"
                :item="item || null"
            />
        </li>
        <li
            v-if="!expanded && items.length > maxItems"
            class="base-expandable-list__item base-expandable-list__expand"
            tabindex="0"
            role="button"
            @click="expanded = true"
            @keydown.enter="expanded = true"
            @keydown.space="expanded = true"
        >
            <slot name="expand-button">
                <span>{{ $t('see-all') }}</span>

                <BaseIcon icon="plus" />
            </slot>
        </li>
    </ul>
</template>

<script setup>
import BaseIcon from './BaseIcon.vue';
import { ref } from 'vue';

defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    maxItems: {
        type: Number,
        default: 5,
        required: false
    },
});

const expanded = ref(false);
</script>

<style lang="less">
.base-expandable-list {
    .list-clean();
}

li.base-expandable-list__item {
    .typography-text();

    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-2xs);
    padding: var(--spacing-sm) .625rem;
    align-items: center;

    border-bottom: 1px solid var(--color-darkest);

    .base-icon {
        font-size: 1.375rem;
    }

    @media @q-md-min {
        .base-icon {
            font-size: 1.5rem;
        }
    }
}

li.base-expandable-list__expand {
    .link--no-underline();
    text-decoration: none;
    text-transform: uppercase;
    justify-content: space-between;
    border-bottom: none;
    padding-left: 0;
    padding-right: 0;

    &:focus-visible {
        outline: 0;
        text-decoration: underline;
    }

    span:not(.base-icon) {
        transform: translateY(3px);
    }

    .base-icon {
        font-size: 1.25rem;
    }

    @media @q-md-min {
        .base-icon {
            font-size: 1.5rem;
        }
    }
}
</style>
